import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";

const theme = createTheme({
  components: {
    MuiSnackbar: {
      variants: [
        {
          props: { variant: "error" },
          style: {
            "& .MuiSnackbarContent-root": {
              background: "#c34747",
            },
          },
        },
        {
          props: { variant: "success" },
          style: {
            "& .MuiSnackbarContent-root": {
              background: "#078728",
            },
          },
        },
        {
          props: { variant: "warning" },
          style: {
            "& .MuiSnackbarContent-root": {
              background: "#dd8a20",
            },
          },
        },
      ],
    },
  },
});

export default function CustomSnackbar(props) {
  let [open, setOpen] = React.useState(props.open);
  // let open = props.open

  const handleClose = () => {
    setOpen(false);
  };

  let icon;
  switch (props.variant) {
    case "success":
      icon = <CheckCircleIcon />;
      break;
    case "error":
      icon = <ErrorIcon />;
      break;
    case "warning":
      icon = <WarningIcon />;
      break;
    default:
      icon = null;
  }

  const action = (
    <React.Fragment>
      {icon && (
        <IconButton size="small" color="inherit" onClick={handleClose}>
          {icon}
        </IconButton>
      )}
      {props.message} {/* Message placed after the icon */}
    </React.Fragment>
  );

  return (
    <ThemeProvider theme={theme}>
      <Snackbar
        id="test-snackbar"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        variant={props.variant}
        open={props.open}
        autoHideDuration={5000}
        message={action}
        // action={action}
      />

     <div
        id="hidden-snackbar"
        style={{
          visibility: 'hidden',
          position: 'absolute',
          height: 0,
          overflow: 'hidden',
        }}
      >
        {props.message}
      </div>
    </ThemeProvider>
  );
}
